import { Box, Grid, Typography } from '@mui/material';
import CountDownTimer from 'src/components/CountDownTimer/CountDownTimer';
import { Lottery } from 'src/util/types';
import PossiblePrizes from 'src/content/pages/external/PossiblePrizes';

function CurrentLottery(props: { lotteryData: Lottery }) {
  return (
    <>
      <Grid spacing={0}
        container
      >
        <Grid item xs={12} md={12}>
          
          <Grid md={12} padding={1}
            container
            sx={{
              maxWidth: '100%',
              justifyContent: 'space-around',
              direction: 'horizontal'
            }}
          >
            <CountDownTimer endTime={new Date(props.lotteryData.endDate).getTime() / 1000} />
          </Grid>
          <Box p={2} textAlign="center">
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                letterSpacing: 2,
                textTransform: 'uppercase',
                color: 'rgba(255,255,255,0.9)'
              }}
            >
              {new Date(props.lotteryData.endDate).getDate() === new Date(Date.now()).getDate() ? 'Heute' : new Date(props.lotteryData.endDate).toLocaleDateString('de-DE')}
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontFamily: "'Space Grotesk', 'Roboto', sans-serif",
                color: '#fff',
                mt: 1,
                textShadow: '0 8px 24px rgba(0,0,0,0.45)'
              }}
            >
              {new Date(props.lotteryData.endDate).toLocaleTimeString()}
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', mt: 1 }}>
              Sei bereit – die nächste Ziehung steht kurz bevor.
            </Typography>
          </Box>
          <PossiblePrizes prizes={props.lotteryData.prizes} />
        </Grid>
      </Grid>
    </>
  );
}

export default CurrentLottery;
